import React from 'react';
import { Row, Col, Button } from 'antd';
import { useSelector } from 'react-redux';
import { localeSelector } from 'src/selector/app';
import RutechRobotPageContent from 'src/consts/poswebsite_content/rutech_robot';
import ProductPage from 'src/components/POSWebsite/Pages/ProductPage';
import CommonSection from 'src/components/POSWebsite/CommonSection';
import { FormattedMessage, useIntl } from 'react-intl';
import indexStyle from './index.less';
import { JoinClassName } from 'src/utils/utils';
import UnoptimizedImage from 'src/components/UnoptimizedImage';

const RutechRobot = () => {
  const locale = useSelector(localeSelector);
  const intl = useIntl();
  return (
    <ProductPage
      pageId={'pos-rutech-robot'}
      pageContent={RutechRobotPageContent}
      featureCardStyle="border_card"
      whyChowbusShowModel="lightGray_background"
      getADemoShowModel="white_background"
      customerCaseKeys={[
        '/hot-pot/liuyishou-hotpot',
        '/full-service/xiangs-hunan-kitchen',
        '/sushi-ramen/shinya-ramen-house',
      ]}
      // templateMode='loyalty_waitlist'
    >
      <CommonSection
        title={RutechRobotPageContent.features01[locale].title}
        outerClassName={JoinClassName(indexStyle.robotsOverview)}
      >
        <div className="overview">
          <div style={{ textAlign: 'center' }}>
            <Button type="primary" className="action-button" target="_blank" href="https://www.rutechusa.com/">
              <FormattedMessage id="rutech.robots.visit.button" />
            </Button>
          </div>
          <div className="rutechRobotsOverviewContainer">
            <picture>
              <source
                type="image/webp"
                srcSet={`${process.env.ASSETS_PREFIX}/products/products_rutech_robots_overview.webp`}
              />
              <img
                src={`${process.env.ASSETS_PREFIX}/products/products_rutech_robots_overview.png`}
                alt={'RuTech Robot overview'}
              ></img>
            </picture>
          </div>
        </div>
      </CommonSection>
    </ProductPage>
  );
};

export default RutechRobot;

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}
